"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sortFillAddressesDates;

var _dateFns = require("date-fns");

var _lodash = require("lodash");

var ADDRESS_TYPES = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function sortFillAddressesDates() {
  var dirtyAddresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : []; // Sort before mapping so we can set end dates easily

  var sortedAddresses = (0, _lodash.orderBy)(dirtyAddresses.filter(function (add) {
    return add != null && add.type !== ADDRESS_TYPES.MAILING;
  }), ['startedAt', 'endedAt'], ['desc', 'desc']); // Map

  return sortedAddresses.map(function (address, index, array) {
    // If we have dates, don't do anything
    if (address.startedAt != null && address.endedAt != null) return address; // If it's the first item and no end date, add endDate

    if (index === 0 && address.endedAt == null) {
      return _objectSpread({}, address, {
        endedAt: (0, _dateFns.format)(new Date(), 'yyyy-MM-dd')
      });
    } // If missing an end date should pull from more recent start date


    if (address.endedAt == null && array[index - 1]) {
      return _objectSpread({}, address, {
        endedAt: array[index - 1].startedAt
      });
    } // TODO: Handle missing start dates


    return address;
  });
}